export default "__VITE_ASSET__d3968fd8__"